module.exports = __webpack_public_path__ + "static/media/rvu_logo.4f3a604e.svg";